/*
 * vrtUser.us
 * vue router: User
 */
import type { RouteRecordRaw } from 'vue-router';
//
const vrtUser: RouteRecordRaw = {
  path: '/eservices/user',
  name: 'vrtUser',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    {
      path: 'myprofile',
      name: 'vrtUserMyProfile',
      component: () => import('./vpgUserMyProfile.vue'),
    },
    {
      path: 'changemypassword',
      name: 'vrtUserChangeMyPassword',
      component: () => import('./vpgUserMyPasswordChange.vue'),
    },
    {
      path: 'hrguidelines',
      name: 'vrtUserHRGuidelines',
      component: () => import('./vpgUserHRGuidelines.vue'),
    },
    {
      path: 'disciplinaryguidelines',
      name: 'vrtUserDisciplinaryGuidelines',
      component: () => import('./vpgUserDisciplinaryGuidelines.vue'),
    },
    {
      path: 'medicalleaveguidelines',
      name: 'vrtUserMedicalLeaveGuidelines',
      component: () => import('./vpgUserMedicalLeaveGuidelines.vue'),
    },
    {
      path: 'adminhruserlist',
      name: 'vrtAdminHRUserList',
      component: () => import('./vpgAdminHRUserList.vue'),
    },
    {
      path: 'admincreateuser',
      name: 'vrtAdminUserCreate',
      component: () => import('./vpgAdminUserCreate.vue'),
    },
    {
      path: 'adminuserlist',
      name: 'vrtAdminUserList',
      component: () => import('./vpgAdminUserList.vue'),
    },
    {
      path: 'adminuserlistoperate',
      name: 'vrtAdminUserListOperate',
      component: () => import('./vpgAdminUserListOperate.vue'),
    },
    {
      path: 'adminuserportrait',
      name: 'vrtAdminUserPortrait',
      component: () => import('./vpgAdminUserPortrait.vue'),
    },
    //
    {
      path: 'adminuserqualificationlucategorylist',
      name: 'vrtAdminUserQualificationLUCategoryList',
      component: () => import('./vpgAdminUserQualificationLUCategoryList.vue'),
    },
    {
      path: 'adminuserqualificationlucategoryoperate',
      name: 'vrtAdminUserQualificationLUCategoryOperate',
      component: () => import('./vpgAdminUserQualificationLUCategoryOperate.vue'),
    },
    {
      path: 'adminuserqualificationluclasslist',
      name: 'vrtAdminUserQualificationLUClassList',
      component: () => import('./vpgAdminUserQualificationLUClassList.vue'),
    },
    {
      path: 'adminuserqualificationluclassoperate',
      name: 'vrtAdminUserQualificationLUClassOperate',
      component: () => import('./vpgAdminUserQualificationLUClassOperate.vue'),
    },
    //
    {
      path: 'adminuserstaffbulist',
      name: 'vrtAdminUserStaffBUList',
      component: () => import('./vpgAdminUserStaffBUList.vue'),
    },
    {
      path: 'adminuserstaffbuoperate',
      name: 'vrtAdminUserStaffBUOperate',
      component: () => import('./vpgAdminUserStaffBUOperate.vue'),
    },
    {
      path: 'adminuserstaffpositionlist',
      name: 'vrtAdminUserStaffPositionList',
      component: () => import('./vpgAdminUserStaffPositionList.vue'),
    },
    {
      path: 'adminuserstaffpositionoperate',
      name: 'vrtAdminUserStaffPositionOperate',
      component: () => import('./vpgAdminUserStaffPositionOperate.vue'),
    },
    //
    {
      path: 'adminuserluuserrolelist',
      name: 'vrtAdminUserLUUserRoleList',
      component: () => import('./vpgAdminUserLUUserRoleList.vue'),
    },
    {
      path: 'adminuseruserluuserroleoperate',
      name: 'vrtAdminUserLUUserRoleOperate',
      component: () => import('./vpgAdminUserLUUserRoleOperate.vue'),
    },
  ],
};
//
export default vrtUser;
//#end#
